"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinReasonEnum = void 0;
var WinReasonEnum;
(function (WinReasonEnum) {
    WinReasonEnum["ACE"] = "ACE";
    WinReasonEnum["DOUBLE_FAULT"] = "DOUBLE_FAULT";
    WinReasonEnum["ERROR"] = "ERROR";
    WinReasonEnum["FORCED"] = "FORCED";
    WinReasonEnum["NET_CORD"] = "NET_CORD";
    WinReasonEnum["PENALTY"] = "PENALTY";
    WinReasonEnum["UNFORCED"] = "UNFORCED";
    WinReasonEnum["WINNER"] = "WINNER";
})(WinReasonEnum || (exports.WinReasonEnum = WinReasonEnum = {}));
//# sourceMappingURL=win_reason.js.map